<template>
  <div class="general_frame">
    <div class="general_title">{{ title }}</div>
    <div class="general_title_sub">{{ subTitle }}</div>
    <div class="general_tval">
      <An
        :numberFormat="numberFormat"
        :moneyFormat="moneyFormat"
        :percentFormat="percentFormat"
        :number="tval"
      />
    </div>
    <div
      v-if="prct"
      class="general_arrow"
      :style="{ transform: 'rotate(' + arrow + ')' }"
    >
      →
    </div>

    <div class="general_prct"><An :number="positivePrct" /> %</div>
  </div>
</template>

<script>
import An from "@/components/AnimateNumber.vue";

export default {
  components: { An },
  props: {
    title: {
      type: String,
      required: true,
    },
    subTitle: {
      type: String,
      required: false,
      default: "",
    },
    tval: {
      type: Number,
      required: true,
    },
    prct: {
      type: Number,
      required: false,
      default: 0,
    },
    numberFormat: {
      type: Boolean,
      required: false,
      default: false,
    },
    moneyFormat: {
      type: Boolean,
      required: false,
      default: false,
    },
    percentFormat: {
      type: Boolean,
      required: false,
      default: false,
    },
    arrow: {
      type: String,
      required: false,
      default: "",
    },
  },
  computed: {
    positivePrct() {
      return Math.abs(this.prct);
    },
  },
};
</script>

<style scoped>
.general_title {
  font-size: 1em;
  font-weight: bold;
  color: teal;
}
.general_title_sub {
  position: absolute;
  top: 22px;
  left: 12px;
}
.general_tval {
  padding: 8px 6px;
  font-size: 1.6em;
  color: darkred;
  position: absolute;
  top: 39px;
  right: 8px;
}
.general_prct {
  position: absolute;
  right: 11px;
  bottom: 0px;
  color: #868686;
  font-size: 1.8em;
}
.general_arrow {
  position: absolute;
  bottom: 0;
  left: 154px;
  font-size: 1.6rem;
  color: gray;
}
.general_frame {
  background-color: white;
  border-radius: 4px;
  box-shadow: 0 0 3px 0 #ccc;
  padding: 8px 12px;
  width: 266px;
  position: relative;
  height: 126px;
}
</style>

